import React from 'react'
import { Container, Row, Col } from "react-bootstrap";
import Particle from './Particle'
import Typing from './Typing'
import Tilt from "react-parallax-tilt";
import Home2 from './Home2';
import Fade from 'react-reveal/Fade';
import {
    AiFillGithub,
    AiOutlineTwitter,
    AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn,FaFacebookF,FaGoogle } from "react-icons/fa";
import Certification from './Certification';
import Projects from './Projects';
import Contactus from './Contactus';
import Toolkit from './Toolkit';

export default function Home() {
    return (
        <section id="home" className="home-section">
            <Container fluid id="home" >
                <Particle />
                <Container className="home-content">
                    <Row>
                        <Col md={8} className="home-header">
                            <h1 style={{ paddingBottom: 15, fontSize: '175px' }} className="heading">
                                Hi There! <span className="wave" role="img" aria-labelledby="wave">👋🏻</span>
                            </h1>

                            <h1 className="heading-name">
                                I'M
                                <strong className="main-name"> ARMAN SINGH</strong>
                            </h1>

                            <div className="typing-homeclass">
                                <Typing />
                            </div>
                            {/* <div className='sociallink-home'>
                                <ul className="homeaboutsociallinks">
                                    <li className="socialicons">
                                        <a
                                            href="https://github.com/aramanrajput"
                                            target="_blank"
                                            rel="noreferrer"
                                            className="iconcolour  homesocialicons"
                                        >
                                            <AiFillGithub />
                                        </a>
                                    </li>
                                    <li className="socialicons">
                                        <a
                                            href="https://www.twitter.com/#!/gurpreet_186/"
                                            target="_blank"
                                            rel="noreferrer"
                                            className="iconcolour  homesocialicons"
                                        >
                                            <AiOutlineTwitter />
                                        </a>
                                    </li>
                                    <li className="socialicons">
                                        <a
                                            href="https://www.linkedin.com/in/armansingh47/"
                                            target="_blank"
                                            rel="noreferrer"
                                            className="iconcolour  homesocialicons"
                                        >
                                            <FaLinkedinIn />
                                        </a>
                                    </li>
                              
                                    <li className="socialicons">
                                        <a
                                            href="https://www.facebook.com/profile.php?id=100013495656880"
                                            target="_blank"
                                            rel="noreferrer"
                                            className="iconcolour homesocialicons"
                                        >
                                            <FaFacebookF />
                                        </a>
                                    </li>
                                    <li className="socialicons">
                                        <a
                                            href="mailto:armanrajput992@gmail.com/"
                                            target="_blank"
                                            rel="noreferrer"
                                            className="iconcolour homesocialicons"
                                        >
                                            <FaGoogle />
                                        </a>
                                    </li>
                                </ul>
                            </div> */}
                                
                        </Col>
                        <Col md={4} style={{ paddingBottom: 20 }}>
                            <div className="img-home-main">
                            <Tilt>
                                <Fade cascade>
                                    <img src="./arman.jpg" alt="home pic" style={{"borderRadius":"50%"}} className="img-fluid" />
                                </Fade>
                            </Tilt>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Container>
            <Home2 />
            {/* <Certification/> */}
            <Toolkit/>
            <Projects/>
            <Contactus />
        </section>
    )
}
